import axios from '../../utils/axios';

export const updatePromotionStatus = (promotionId: string, status: any) => {
  return axios.put(`/api/v1/servicepackages/patient/promotion/${promotionId}`, { status });
};
